import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { name: '首页', path: '/' },
      { name: '文章分类', path: '/category' },
      { name: '关于我们', path: '/about' },
      { name: '下载安装', path: '/category/download' },
      { name: '使用指南', path: '/category/guide' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { name: '常见问题', path: '/category/faq-cat' },
      { name: '安全认证', path: '/category/security' },
      { name: '版本更新', path: '/category/update' },
      { name: '联系我们', path: '/about' },
    ],
  },
  {
    title: '法律信息',
    links: [
      { name: '隐私政策', path: '/article/7' },
      { name: '用户协议', path: '/article/7' },
      { name: '知识产权', path: '/article/7' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-vip-crown-line text-2xl" style={{ color: 'oklch(var(--primary-400))' }}></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                皇冠App
              </span>
            </Link>
            <p className="text-sm text-background-50/60 leading-relaxed mt-3">
              皇冠App官方正版下载平台，致力于为用户提供安全、稳定、流畅的移动应用体验。始终以用户安全和隐私保护为首要原则。
            </p>
            <div className="flex items-center gap-4 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-50/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} 皇冠App 版权所有 | 皇冠科技
          </p>
          <p className="text-xs text-background-50/50">
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow noopener" className="hover:text-background-50/70 transition-colors">
              京ICP备2024XXXXXXXX号-1
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}